// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

// Utilities
import {
  populatePath,
  storyTheme,
  getNextEngagementUrl,
  getUtmParams,
  featureFlagEnabled,
} from 'common/utils/helpers';

// Enumerables
import PublicStatus from 'common/enums/PublicStatus';

// Routes
import Routes from 'routes';

// Components
import CallToActionTile from 'project/components/CallToActionTile';

const buttonLabel = (publicStatus, displayEngagementReport, t, engagementType) => {
  if (publicStatus === PublicStatus.OPEN) {
    if (storyTheme()) {
      return t('project.read_more');
    }

    if (engagementType === 'live') {
      return null;
    }

    return t('project.participate_now');
  }

  if (displayEngagementReport) {
    return t('engagement_report.view_results');
  }

  return null;
};

const EngagementTile = ({ engagement, match, t }) => {
  const {
    id,
    publicStatus,
    title,
    startTime,
    endTime,
    description,
    heroImage,
    minutesToComplete,
    slug,
    project,
    engagementReport,
    uuid,
    engagementType,
    timezoneIdentifier: timezone,
  } = engagement;
  const engagementReportUrl =
    window.location.origin +
    populatePath(Routes.ENGAGEMENT_REPORT, {
      locale: 'en', // TODO: Remove hardcoded locale
      projectId: project?.slug || project?.id,
      engagementReportId: engagementReport?.slug,
    });

  let engagementUrl = populatePath(Routes.ENGAGEMENT, {
    ...match.params,
    engagementId: slug || id,
  });
  if (featureFlagEnabled('publishing_ui')) {
    engagementUrl = getNextEngagementUrl(match.params.locale, uuid);
  }
  const utmQueryString = getUtmParams();
  const engagemenUrlWithUtm = `${engagementUrl}${utmQueryString}`;

  const displayEngagementReport =
    publicStatus === PublicStatus.CLOSED &&
    engagementReport?.id &&
    engagementReport?.publiclyVisible;

  return (
    <CallToActionTile
      publicStatus={publicStatus}
      title={title}
      id={id}
      description={description}
      heroImage={heroImage}
      url={displayEngagementReport ? engagementReportUrl : engagemenUrlWithUtm}
      startTime={startTime}
      endTime={endTime}
      timezone={timezone}
      minutesToComplete={minutesToComplete}
      buttonLabel={buttonLabel(publicStatus, displayEngagementReport, t, engagementType)}
    />
  );
};

EngagementTile.propTypes = {
  engagement: PropTypes.objectOf({}).isRequired,
  match: PropTypes.objectOf({}).isRequired,
  t: PropTypes.func.isRequired,
};

export default withRouter(withTranslation()(EngagementTile));
